export interface UserState<UserType> {
    logged: boolean,
    has_permission: boolean,
    user: UserType
}

export class UserAuthConfig {
    baseURL: string
    userPath: string
    authPath: string
    clientID: string
    clientSecret: string
}

export interface AuthToken {
    access_token?: string,
    refresh_token?: string,
    token_type?: string,
    expires_in?: number,
    expireTime?: number,
    authorization?: string
}



// WEBPACK FOOTER //
// ./src/modules/mrk-user-auth/user-auth-models.ts